// src/components/NotFoundPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaCompass, FaMountain, FaLeaf, FaRoute } from 'react-icons/fa';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="mindscape">
        <div className="mountain-range">
          <div className="mountain mountain-1"></div>
          <div className="mountain mountain-2"></div>
          <div className="mountain mountain-3"></div>
          <div className="sun"></div>
        </div>
        
        <div className="path">
          <div className="path-line"></div>
          <div className="path-dots">
            <div className="path-dot dot-1"></div>
            <div className="path-dot dot-2"></div>
            <div className="path-dot dot-3"></div>
          </div>
        </div>
      </div>
      
      <div className="content">
        <div className="meditation-circle">
          <div className="circle-outer"></div>
          <div className="circle-inner"></div>
          <div className="focus-point"></div>
          <div className="compass-icon">
            <FaCompass />
          </div>
        </div>
        
        <h1 className="title">404 - Página Não Encontrada</h1>
        
        <div className="message">
          <p>Você parece ter se afastado do seu caminho de desenvolvimento...</p>
          <p className="reflection">Mas toda jornada de crescimento tem seus desvios.</p>
        </div>
        
        <div className="path-symbols">
          <div className="symbol">
            <FaMountain className="icon" />
            <span>Desafios</span>
          </div>
          <div className="symbol">
            <FaLeaf className="icon" />
            <span>Crescimento</span>
          </div>
          <div className="symbol">
            <FaRoute className="icon" />
            <span>Caminho</span>
          </div>
        </div>
        
        <Link to="/" className="return-button">
          Retomar a Jornada
        </Link>
        
        <div className="breath-instruction">
          <p>Respire fundo. Encontre seu centro. Continue sua evolução.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;